import { cx } from "class-variance-authority";
import { ChevronRight } from "lucide-react";
import React from "react";

import { ChronologyViewType } from "./types";

interface VisitsTableGroupHeaderProps {
  groupKey: string;
  groupLabel: string;
  visitCount: number;
  viewType: ChronologyViewType;
  formatVisitType?: (id: string) => string;
  isExpanded: boolean;
  onToggle: () => void;
}

const ROW_CLASS =
  "flex w-full items-center gap-2 border-b border-neutral-200 bg-neutral-50 px-4 py-2.5 text-left";

export const VisitsTableGroupHeader: React.FC<VisitsTableGroupHeaderProps> = ({
  groupKey,
  groupLabel,
  visitCount,
  viewType,
  formatVisitType,
  isExpanded,
  onToggle,
}) => {
  const isCollapsible = viewType !== ChronologyViewType.DATE;
  const label =
    viewType === ChronologyViewType.VISIT_TYPE && formatVisitType
      ? formatVisitType(groupKey)
      : groupLabel;

  const content = (
    <>
      {isCollapsible && (
        <ChevronRight
          size={14}
          strokeWidth={2.5}
          aria-hidden="true"
          className={cx(
            "shrink-0 text-neutral-400 transition-transform duration-200",
            isExpanded && "rotate-90"
          )}
        />
      )}
      <span className="text-sm font-semibold text-neutral-900">{label}</span>
      <span className="text-2xs font-semibold uppercase tracking-micro text-neutral-500">
        {visitCount} visit{visitCount !== 1 ? "s" : ""}
      </span>
    </>
  );

  if (!isCollapsible) {
    return (
      <div data-group-key={groupKey} className={ROW_CLASS}>
        {content}
      </div>
    );
  }

  return (
    <button
      type="button"
      data-group-key={groupKey}
      onClick={onToggle}
      className={cx(
        ROW_CLASS,
        "transition-colors hover:bg-neutral-100 focus-visible:shadow-focus-inset focus-visible:outline-none"
      )}
    >
      {content}
    </button>
  );
};
